import React, { useCallback, useEffect, useState } from "react";

import { gql, useMutation } from "@apollo/client";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

import PublicPage from "../components/layout/PublicPage";

export default function ForgotPassword() {
  const [username, setUsername] = useState("");
  const [validated, setValidated] = useState(false);
  const [canSubmit, setCanSubmit] = useState(false);

  const [errors, setErrors] = useState({});

  const dispatch = useDispatch();

  const [doForgotPassword, { data, loading, error }] = useMutation(
    gql`
      mutation Mutation($username: String!) {
        forgot_password(username: $username)
      }
    `
  );
  useEffect(() => {
    let errors = {};
    let canSubmit = true;
    if (!username) {
      errors.username = "Veuillez saisir votre e-mail";
      canSubmit = false;
    } else if (!username.includes("@")) {
      errors.username = "Veuillez saisir un e-mail valide";
      canSubmit = false;
    }

    setErrors(errors);
    setCanSubmit(canSubmit);
  }, [username, setErrors]);

  useEffect(() => {
    if (error) {
      switch (error?.message) {
        case "user_not_found":
          setErrors({
            username: "Cet identifiant n'existe pas",
          });

          break;
        default:
          setErrors({
            username: "Identifiant incorrect",
          });
          break;
      }
      setValidated(true);
    }
  }, [data, error, setValidated, dispatch, setErrors]);

  const submit = useCallback(
    (event) => {
      (async () => {
        event.preventDefault();
        event.stopPropagation();
        setValidated(true);
        setErrors({});

        try {
          let res = await doForgotPassword({
            variables: {
              username,
            },
          });
          if (res.data.forgot_password) {
            toast.success(
              "Un e-mail de réinitialisation de mot de passe a été envoyé à l'adresse e-mail saisie."
            );
          } else {
            toast.error(
              "Nous n'avons pas pu réinitialiser votre mot de passe."
            );
          }
        } catch (error) {
          console.error(error);
        }
      })();
    },
    [doForgotPassword, username, setValidated]
  );

  return (
    <PublicPage title="Réinitialisation de mot de passe">
      <div className="container">
        <div
          className="card mt-4"
          style={{ maxWidth: "400px", margin: "auto" }}
        >
          <div className="card-body">
            <div>
              <form onSubmit={submit}>
                <div className="mb-4 form-field">
                  <label htmlFor="email" className="form-label">
                    E-mail <span className="required">*</span>
                  </label>
                  <div className="text-secondary fst-italic mb-3">
                    Un e-mail de réinitialisation de mot de passe sera envoyé à
                    l'adresse e-mail saisie.
                  </div>
                  <input
                    type="email"
                    className={
                      "form-control" +
                      (validated && errors.username ? " is-invalid" : "")
                    }
                    id="email"
                    placeholder="E-mail"
                    name="email"
                    onChange={(event) => {
                      setUsername(event.target.value);
                    }}
                    value={username}
                  />
                  {errors.username && (
                    <div className="invalid-feedback">{errors.username}</div>
                  )}
                </div>

                <div className="mb-4 form-field">
                  <Link to="/login">Se connecter</Link>
                </div>
                <div className="w-100">
                  <button
                    type="submit"
                    className="btn btn-primary float-end"
                    disabled={loading || !canSubmit}
                  >
                    Démander la réinitialisation
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </PublicPage>
  );
}
